// extracted by mini-css-extract-plugin
export default {"overlayContainer":"styles_overlayContainer__AoB0h","overlayContent":"styles_overlayContent__QejEs","fadeIn":"styles_fadeIn__0GlnF"};